import { Translations } from './en';

const fr: Translations = {
  addManager: 'Ajouter un manager',
  lastName: {
    placeholder: 'ex. Nom',
    errorMessage: 'Le nom de famille est obligatoire',
    label: 'Nom',
  },
  firstName: {
    placeholder: 'ex. Thomas',
    errorMessage: 'Le prénom est obligatoire',
    label: 'Prénom',
  },
  phone: {
    placeholder: '01 28 43 26 69',
    errorMessage: 'Le numéro de téléphone est obligatoire et doit contenir seulement 10 chiffres',
    label: 'Téléphone',
  },
  email: {
    placeholder: 'nom@domaine.com',
    errorMessage: 'Veuillez introduire une adresse e-mail valide',
    label: 'Email',
  },
  role: {
    errorMessage: 'Le rôle est obligatoire',
    label: 'Rôle',
    selectOptions: {
      worker: 'Contributeur',
      candidate: 'Candidat',
      manager: 'Manager',
      admin: 'Admin',
    },
  },
};

export default fr;
